/**
 * Web stub for OneSignal and other native-only modules
 * Provides compatibility layer for web platform
 */
import React from 'react';

// Default export for modules expecting a component or class
const EmptyComponent = (props: any) => React.createElement(React.Fragment, null);

// OneSignal stub with all commonly used methods
export const OneSignal = {
  // Initialization methods
  setLogLevel: () => {},
  setAppId: () => {},
  promptForPushNotificationsWithUserResponse: () => Promise.resolve(),
  disablePush: () => Promise.resolve(),
  getDeviceState: () => Promise.resolve({ isPushDisabled: false }),
  setExternalUserId: () => Promise.resolve(),
  // Event handlers
  addTrigger: () => {},
  removeTrigger: () => {},
  addEventListener: () => {},
  removeEventListener: () => {},
  setNotificationOpenedHandler: () => {},
  setNotificationWillShowInForegroundHandler: () => {},
  // Version method (for compatibility)
  getVersion: () => Promise.resolve(''),
  // Additional common methods
  inAppMessaging: {
    paused: () => Promise.resolve(false),
    setPaused: () => Promise.resolve(),
  },
  User: {
    pushSubscription: {
      getPushSubscriptionId: () => Promise.resolve(''),
    },
  },
  // Silence any other method calls
} as any;

// Export common icon components as empty fragments
export const Ionicons = EmptyComponent;
export const MaterialIcons = EmptyComponent;
export const MaterialCommunityIcons = EmptyComponent;
export const FontAwesome = EmptyComponent;

// Export modal as empty component
export const Modal = EmptyComponent;

// Export AnimatedLottieView
export const AnimatedLottieView = EmptyComponent;

// Generic fallback for any named exports
export const View = EmptyComponent;
export const Text = EmptyComponent;
export const TouchableOpacity = EmptyComponent;

// Default export - also include OneSignal as default for compatibility
export default { ...OneSignal };

